import {
  addObj,
  getAll,
  getPage,
  getDetail,
  getMyUserGroupAll,
  getMyUserGroupPage,
  changeBusinessUser,
  getMyBusinessPage,
  cancel,
  confirmRecept,
  checkRenewalOrder,
  checkVehicleInfo,
  refuseService,
  addToRemark,
  confirmFileReady,
  confirmReRegistration
} from '@/api/jt808servcombineorderserv'

export default {
  state: {
    state_Jt808ServCombineOrder_AddObjResult: null,
    state_Jt808ServCombineOrder_GetAllResult: null,
    state_Jt808ServCombineOrder_GetPageResult: null,
    state_Jt808ServCombineOrder_GetDetailResult: null,
    state_Jt808ServCombineOrder_GetMyUserGroupAllResult: null,
    state_Jt808ServCombineOrder_GetMyUserGroupPageResult: null,
    state_Jt808ServCombineOrder_ChangeBusinessUserResult: null,
    state_Jt808ServCombineOrder_GetMyBusinessPageResult: null,
    state_Jt808ServCombineOrder_CancelResult: null,
    state_Jt808ServCombineOrder_ConfirmReceptResult: null,
    state_Jt808ServCombineOrder_CheckRenewalOrderResult: null,
    state_Jt808ServCombineOrder_CheckVehicleInfoResult: null,
    state_Jt808ServCombineOrder_RefuseServiceResult: null,
    state_Jt808ServCombineOrder_AddToRemarkResult: null,
    state_Jt808ServCombineOrder_ConfirmFileReadyResult: null,
    state_Jt808ServCombineOrder_ConfirmReRegistrationResult: null
  },
  mutations: {
    SET_JT808SERVCOMBINEORDER_ADDOBJ_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_AddObjResult = rst
    },
    SET_JT808SERVCOMBINEORDER_GETALL_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_GetAllResult = rst
    },
    SET_JT808SERVCOMBINEORDER_GETPAGE_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_GetPageResult = rst
    },
    SET_JT808SERVCOMBINEORDER_GETDETAIL_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_GetDetailResult = rst
    },
    SET_JT808SERVCOMBINEORDER_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_GetMyUserGroupAllResult = rst
    },
    SET_JT808SERVCOMBINEORDER_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_GetMyUserGroupPageResult = rst
    },
    SET_JT808SERVCOMBINEORDER_CHANGEBUSINESSUSER_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_ChangeBusinessUserResult = rst
    },
    SET_JT808SERVCOMBINEORDER_GETMYBUSINESSPAGE_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_GetMyBusinessPageResult = rst
    },
    SET_JT808SERVCOMBINEORDER_CANCEL_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_CancelResult = rst
    },
    SET_JT808SERVCOMBINEORDER_CONFIRMRECEPT_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_ConfirmReceptResult = rst
    },
    SET_JT808SERVCOMBINEORDER_CHECKRENEWALORDER_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_CheckRenewalOrderResult = rst
    },
    SET_JT808SERVCOMBINEORDER_CHECKVEHICLEINFO_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_CheckVehicleInfoResult = rst
    },
    SET_JT808SERVCOMBINEORDER_REFUSESERVICE_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_RefuseServiceResult = rst
    },
    SET_JT808SERVCOMBINEORDER_ADDTOREMARK_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_AddToRemarkResult = rst
    },
    SET_JT808SERVCOMBINEORDER_CONFIRMFILEREADY_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_ConfirmFileReadyResult = rst
    },
    SET_JT808SERVCOMBINEORDER_CONFIRMREREGISTRATION_RESULT: (state, rst) => {
      state.state_Jt808ServCombineOrder_ConfirmReRegistrationResult = rst
    }
  },
  actions: {
    Jt808ServCombineOrderServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_GetMyUserGroupAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_GETMYUSERGROUPALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_GETMYUSERGROUPALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_GetMyUserGroupPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_GETMYUSERGROUPPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_GETMYUSERGROUPPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_ChangeBusinessUser ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        changeBusinessUser(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_CHANGEBUSINESSUSER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_CHANGEBUSINESSUSER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_GetMyBusinessPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyBusinessPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_GETMYBUSINESSPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_GETMYBUSINESSPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_Cancel ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        cancel(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_CANCEL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_CANCEL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_ConfirmRecept ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmRecept(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_CONFIRMRECEPT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_CONFIRMRECEPT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_CheckRenewalOrder ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        checkRenewalOrder(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_CHECKRENEWALORDER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_CHECKRENEWALORDER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_CheckVehicleInfo ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        checkVehicleInfo(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_CHECKVEHICLEINFO_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_CHECKVEHICLEINFO_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_RefuseService ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        refuseService(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_REFUSESERVICE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_REFUSESERVICE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_AddToRemark ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addToRemark(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_ADDTOREMARK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_ADDTOREMARK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_ConfirmFileReady ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmFileReady(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_CONFIRMFILEREADY_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_CONFIRMFILEREADY_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Jt808ServCombineOrderServ_ConfirmReRegistration ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmReRegistration(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_JT808SERVCOMBINEORDER_CONFIRMREREGISTRATION_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_JT808SERVCOMBINEORDER_CONFIRMREREGISTRATION_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_Jt808ServCombineOrder_AddObjResult: state => {
      return state.state_Jt808ServCombineOrder_AddObjResult
    },
    get_Jt808ServCombineOrder_GetAllResult: state => {
      return state.state_Jt808ServCombineOrder_GetAllResult
    },
    get_Jt808ServCombineOrder_GetPageResult: state => {
      return state.state_Jt808ServCombineOrder_GetPageResult
    },
    get_Jt808ServCombineOrder_GetDetailResult: state => {
      return state.state_Jt808ServCombineOrder_GetDetailResult
    },
    get_Jt808ServCombineOrder_GetMyUserGroupAllResult: state => {
      return state.state_Jt808ServCombineOrder_GetMyUserGroupAllResult
    },
    get_Jt808ServCombineOrder_GetMyUserGroupPageResult: state => {
      return state.state_Jt808ServCombineOrder_GetMyUserGroupPageResult
    },
    get_Jt808ServCombineOrder_ChangeBusinessUserResult: state => {
      return state.state_Jt808ServCombineOrder_ChangeBusinessUserResult
    },
    get_Jt808ServCombineOrder_GetMyBusinessPageResult: state => {
      return state.state_Jt808ServCombineOrder_GetMyBusinessPageResult
    },
    get_Jt808ServCombineOrder_CancelResult: state => {
      return state.state_Jt808ServCombineOrder_CancelResult
    },
    get_Jt808ServCombineOrder_ConfirmReceptResult: state => {
      return state.state_Jt808ServCombineOrder_ConfirmReceptResult
    },
    get_Jt808ServCombineOrder_CheckRenewalOrderResult: state => {
      return state.state_Jt808ServCombineOrder_CheckRenewalOrderResult
    },
    get_Jt808ServCombineOrder_CheckVehicleInfoResult: state => {
      return state.state_Jt808ServCombineOrder_CheckVehicleInfoResult
    },
    get_Jt808ServCombineOrder_RefuseServiceResult: state => {
      return state.state_Jt808ServCombineOrder_RefuseServiceResult
    },
    get_Jt808ServCombineOrder_AddToRemarkResult: state => {
      return state.state_Jt808ServCombineOrder_AddToRemarkResult
    },
    get_Jt808ServCombineOrder_ConfirmFileReadyResult: state => {
      return state.state_Jt808ServCombineOrder_ConfirmFileReadyResult
    },
    get_Jt808ServCombineOrder_ConfirmReRegistrationResult: state => {
      return state.state_Jt808ServCombineOrder_ConfirmReRegistrationResult
    }
  }
}
